import { render, staticRenderFns } from "./StockDocumentFilesPanel.vue?vue&type=template&id=0ce26abe&scoped=true"
import script from "./StockDocumentFilesPanel.vue?vue&type=script&lang=js"
export * from "./StockDocumentFilesPanel.vue?vue&type=script&lang=js"
import style0 from "./StockDocumentFilesPanel.vue?vue&type=style&index=0&id=0ce26abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce26abe",
  null
  
)

export default component.exports